export class BlockData {
    constructor(code, desc, size, kms, kvs, angle) {
        this.code = code;
        this.angle = angle;
        this.desc = desc;
        this.size = size;
        this.kms = kms;
        this.kvs = kvs;
    }
}